const CheckPermission = (name) => {
  let check = false;

  if (localStorage.getItem('userInfo')) {
    let data = JSON.parse(localStorage.getItem('userInfo'));
    data.roles.map((item, i) => {
      if (data.vaiTroMacDinhId == item.vaiTroId) {
        let quyens = item.quyen.split(',');
        if (quyens.indexOf(name) != -1) {
          check = true;
        }
      }
    });
  }
  return check;
}

const CheckViewPermission = (data) => {
  let check = false;

  if (localStorage.getItem('userInfo')) {
    let userData = JSON.parse(localStorage.getItem('userInfo'));
    if ((data.donViXuLyGiaiQuyetInfo && data.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == userData.donViId) ||
        (data.donViThamTraXacMinhInfo && data.donViThamTraXacMinhInfo.coQuanQuanLyId == userData.donViId) ||
        (data.donViTheoDoiThucHienInfo && data.donViTheoDoiThucHienInfo.coQuanQuanLyId == userData.donViId) ||
        (data.donViKiemTraDeXuatInfo && data.donViKiemTraDeXuatInfo.coQuanQuanLyId == userData.donViId) ||
        (data.donViXuLyDonChuyenInfo && data.donViXuLyDonChuyenInfo.coQuanQuanLyId == userData.donViId) ||
        (data.donViTiepDanInfo && data.donViTiepDanInfo.coQuanQuanLyId == userData.donViId) ||
        (data.donCuId)
    ) {
      check = true;
    }
  }
  return check;
}

export {CheckPermission, CheckViewPermission};



// WEBPACK FOOTER //
// ./src/components/modules/login/CheckPermission.js